"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderMortgageResult = void 0;
var React = require("react");
var format_1 = require("@/utils/format");
var myokay_donut_1 = require("@okay/myokay-donut");
var MortgageSagaCall_1 = require("@/pages/detail/sagas/MortgageSagaCall");
var MortgageTab_1 = require("@/pages/detail/states/MortgageTab");
var classnames_1 = require("classnames");
var MortgageCommon_1 = require("@/pages/mortagage/components/MortgageCommon");
var renderMortgageResult = function (props) {
    var breakdown = MortgageSagaCall_1.getBreakdown(props.t, props.mortgage).map(function (it, i) {
        return __assign(__assign({}, it), { valueText: format_1.default.currency(Math.ceil(it.value)), active: props.mortgage.activeIndex === i });
    });
    var donutState = {
        items: breakdown,
        value: format_1.default.currency(Math.ceil(props.mortgage.totalExpense)),
        unit: "" + props.t.hkd,
        caption: props.t.totalExpense,
    };
    var onDonutHover = function (item, index) { return props.onDonutHover(item, index); };
    var renderBreakdownRows = function (props, rows) {
        var renderRow = function (row, i) {
            return (React.createElement("div", { key: i, className: "c-mortgage__calrow" },
                React.createElement("div", { className: "c-mortgage__callabel" },
                    React.createElement("span", { style: { backgroundColor: row.color }, className: "c-mortgage__bulb" }),
                    row.name),
                React.createElement("div", { className: "c-mortgage__calvalue" }, format_1.default.comma(Math.ceil(row.value)))));
        };
        return rows.map(renderRow);
    };
    var renderOverview = function (props) {
        return (React.createElement("div", { id: "mortgagebody", className: "c-mortgage__body c-mortgage__body--active" },
            props.mortgage.error ? MortgageCommon_1.renderError(props.mortgage.error, props.tMortgage) : null,
            React.createElement("div", { className: "c-mortgage__payment" },
                React.createElement("div", { className: "c-mortgage__head" }, props.t.monthlyPayment),
                React.createElement("div", { className: "c-mortgage__blocks" },
                    React.createElement("div", { className: "c-mortgage__block c-mortgage__block--lg" },
                        React.createElement("div", { className: "c-mortgage__block-title" }, props.t.monthlyPayment),
                        React.createElement("div", { className: "c-mortgage__block-value" },
                            format_1.default.currencyFull(Math.ceil(props.mortgage.paymentPerMonth)),
                            React.createElement("span", { className: "c-mortgage__block-unit" }, props.t.hkd))),
                    React.createElement("div", { className: "c-mortgage__block" },
                        React.createElement("div", { className: "c-mortgage__block-title" }, props.t.minimumIncome),
                        React.createElement("div", { className: "c-mortgage__block-value" },
                            format_1.default.currencyFull(Math.ceil(props.mortgage.stressTestMonthlyIncome)),
                            React.createElement("span", { className: "c-mortgage__block-unit" }, props.t.hkd))))),
            React.createElement("div", { className: "c-mortgage__breakdown", style: { paddingBottom: '50px' } },
                React.createElement("div", { className: "c-mortgage__head" }, props.t.totalExpenseBreakdown),
                React.createElement("div", { className: "c-mortgage__blocks" },
                    React.createElement("div", { className: "c-mortgage__block c-mortgage__block--lg" },
                        React.createElement("div", { className: "c-mortgage__block-title" }, props.t.totalExpense),
                        React.createElement("div", { className: "c-mortgage__block-value" },
                            format_1.default.currencyFull(Math.ceil(props.mortgage.totalExpense)),
                            React.createElement("span", { className: "c-mortgage__block-unit" }, props.t.hkd))),
                    React.createElement("div", { className: "c-mortgage__block" },
                        React.createElement("div", { className: "c-mortgage__block-title" }, props.t.totalCashOutlay),
                        React.createElement("div", { className: "c-mortgage__block-value" },
                            format_1.default.currencyFull(Math.ceil(props.mortgage.initialCashOutlay)),
                            React.createElement("span", { className: "c-mortgage__block-unit" }, props.t.hkd)))),
                React.createElement("div", { className: "c-mortgage__diagram l-pad l-pad--2" },
                    React.createElement("div", { className: "c-mortgage__cals" },
                        React.createElement("div", { className: "c-mortgage__table" },
                            React.createElement("div", { className: "c-mortgage__calrows" }, renderBreakdownRows(props, breakdown)),
                            React.createElement("div", { className: "c-mortgage__caltotal" },
                                React.createElement("div", { className: "c-mortgage__callabel" }, props.t.total),
                                React.createElement("div", { className: "c-mortgage__calvalue" }, format_1.default.comma(Math.ceil(props.mortgage.totalExpense)))))),
                    React.createElement("div", { className: "c-mortgage__graph" },
                        React.createElement(myokay_donut_1.Donut, __assign({}, donutState, { onHover: onDonutHover })))),
                React.createElement("div", { className: "c-mortgage__summary" },
                    React.createElement("div", { className: "c-mortgage__head" }, props.t.mortgageSummary),
                    React.createElement("div", { className: "l-pad l-pad--2" },
                        React.createElement("table", { className: "c-amortize__table" },
                            React.createElement("thead", { className: "c-amortize__head c-amortize__head--light" },
                                React.createElement("tr", null,
                                    React.createElement("th", { colSpan: 2 }, props.t.monthlyExpense))),
                            React.createElement("tbody", { className: "c-amortize__body" },
                                React.createElement("tr", null,
                                    React.createElement("th", null, props.t.mortgage),
                                    React.createElement("td", null, format_1.default.comma(Math.ceil(props.mortgage.paymentPerMonth))))),
                            React.createElement("tfoot", { className: "c-amortize__foot" },
                                React.createElement("tr", null,
                                    React.createElement("th", null, props.t.total),
                                    React.createElement("td", null, format_1.default.comma(Math.ceil(props.mortgage.paymentPerMonth))))))),
                    React.createElement("div", { className: "l-pad l-pad--2" },
                        React.createElement("table", { className: "c-amortize__table  l-pad l-pad--2" },
                            React.createElement("thead", { className: "c-amortize__head c-amortize__head--light" },
                                React.createElement("tr", null,
                                    React.createElement("th", { colSpan: 2 }, props.t.totalExpense))),
                            React.createElement("tbody", { className: "c-amortize__body" },
                                React.createElement("tr", null,
                                    React.createElement("th", null, props.t.downPayment),
                                    React.createElement("td", null, format_1.default.comma(Math.ceil(props.mortgage.downPayment)))),
                                React.createElement("tr", null,
                                    React.createElement("th", null, props.t.principle),
                                    React.createElement("td", null, format_1.default.comma(Math.ceil(props.mortgage.mortgage)))),
                                React.createElement("tr", null,
                                    React.createElement("th", null, props.t.interest),
                                    React.createElement("td", null, format_1.default.comma(Math.ceil(props.mortgage.interest)))),
                                React.createElement("tr", null,
                                    React.createElement("th", null, props.t.insurance),
                                    React.createElement("td", null, format_1.default.comma(Math.ceil(props.mortgage.insurance)))),
                                React.createElement("tr", null,
                                    React.createElement("th", null, props.t.stampDuty),
                                    React.createElement("td", null, format_1.default.comma(Math.ceil(props.mortgage.stampDuty)))),
                                React.createElement("tr", null,
                                    React.createElement("th", null, props.t.commission),
                                    React.createElement("td", null, format_1.default.comma(Math.ceil(props.mortgage.commission))))),
                            React.createElement("tfoot", { className: "c-amortize__foot" },
                                React.createElement("tr", null,
                                    React.createElement("th", null, props.t.totalExpense),
                                    React.createElement("td", null, format_1.default.comma(Math.ceil(props.mortgage.totalExpense))))))),
                    React.createElement("div", { className: "l-pad l-pad--2" },
                        React.createElement("table", { className: "c-amortize__table  l-pad l-pad--2" },
                            React.createElement("thead", { className: "c-amortize__head c-amortize__head--light" },
                                React.createElement("tr", null,
                                    React.createElement("th", { colSpan: 2 }, props.t.initialTotalCashOutlay))),
                            React.createElement("tbody", { className: "c-amortize__body" },
                                React.createElement("tr", null,
                                    React.createElement("th", null, props.t.downPayment),
                                    React.createElement("td", null, format_1.default.comma(Math.ceil(props.mortgage.downPayment)))),
                                React.createElement("tr", null,
                                    React.createElement("th", null, props.t.stampDuty),
                                    React.createElement("td", null, format_1.default.comma(Math.ceil(props.mortgage.stampDuty)))),
                                React.createElement("tr", null,
                                    React.createElement("th", null, props.t.insurance),
                                    React.createElement("td", null, format_1.default.comma(Math.ceil(props.mortgage.insurance)))),
                                React.createElement("tr", null,
                                    React.createElement("th", null, props.t.commission),
                                    React.createElement("td", null, format_1.default.comma(Math.ceil(props.mortgage.commission))))),
                            React.createElement("tfoot", { className: "c-amortize__foot" },
                                React.createElement("tr", null,
                                    React.createElement("th", null, props.t.totalCashOutlay),
                                    React.createElement("td", null, format_1.default.comma(Math.ceil(props.mortgage.initialCashOutlay))))))),
                    React.createElement("div", { className: "l-pad l-pad--2" },
                        React.createElement("table", { className: "c-amortize__table  l-pad l-pad--2" },
                            React.createElement("thead", { className: "c-amortize__head c-amortize__head--light" },
                                React.createElement("tr", null,
                                    React.createElement("th", { colSpan: 2 }, props.t.stressTest))),
                            React.createElement("tbody", { className: "c-amortize__body" },
                                React.createElement("tr", null,
                                    React.createElement("th", null, props.t.assumedIntrestRate),
                                    React.createElement("td", null,
                                        props.mortgage.interestRate + 3,
                                        "%"))),
                            React.createElement("tfoot", { className: "c-amortize__foot" },
                                React.createElement("tr", null,
                                    React.createElement("th", null, props.t.minimumIncome),
                                    React.createElement("td", null, format_1.default.comma(Math.ceil(props.mortgage.stressTestMonthlyIncome)))))))))));
    };
    var renderSchedule = function (props) {
        var renderTables = function (props) {
            var yearlyTable = [];
            props.mortgage.amortizeTable.map(function (it, i) {
                var year = Math.floor(i / 12);
                if (!yearlyTable[year]) {
                    yearlyTable[year] = [];
                }
                yearlyTable[year].push(it);
            });
            var renderTable = function (yearlyTable, i) {
                var renderTableRow = function (t, k) {
                    return (React.createElement("tr", null,
                        React.createElement("td", null, i * 12 + k + 1),
                        React.createElement("td", null, format_1.default.comma(Math.ceil(t.payment))),
                        React.createElement("td", null, format_1.default.comma(Math.ceil(t.principle))),
                        React.createElement("td", null, format_1.default.comma(Math.ceil(t.interest))),
                        React.createElement("td", null, format_1.default.comma(Math.ceil(t.balance)))));
                };
                return (React.createElement("table", { className: "c-amortize__table" },
                    React.createElement("thead", { className: "c-amortize__head" },
                        React.createElement("tr", null,
                            React.createElement("td", { colSpan: 5 },
                                props.t.year,
                                " ",
                                i + 1)),
                        React.createElement("tr", null,
                            React.createElement("th", null, props.t.noMonth),
                            React.createElement("th", null, props.t.payment),
                            React.createElement("th", null, props.t.principle),
                            React.createElement("th", null, props.t.interest),
                            React.createElement("th", null, props.t.balance))),
                    React.createElement("tbody", { className: "c-amortize__body" }, yearlyTable.map(renderTableRow))));
            };
            return yearlyTable.map(renderTable);
        };
        return (React.createElement("div", { className: "c-mortgage__body c-mortgage__body--active" },
            React.createElement("div", { className: "c-amortize" },
                React.createElement("div", { className: "c-amortize__blocks" },
                    React.createElement("div", { className: "c-amortize__block" }, renderTables(props))))));
    };
    var renderRateTable = function (props) {
        var renderRateRow = function (row, i) {
            return (React.createElement("tr", { key: i },
                React.createElement("td", null, row.rate),
                React.createElement("td", null, format_1.default.comma(Math.ceil(row.ten))),
                React.createElement("td", null, format_1.default.comma(Math.ceil(row.fifteen))),
                React.createElement("td", null, format_1.default.comma(Math.ceil(row.twenty))),
                React.createElement("td", null, format_1.default.comma(Math.ceil(row.twentyFifth))),
                React.createElement("td", null, format_1.default.comma(Math.ceil(row.thirty)))));
        };
        return (React.createElement("div", { className: "c-mortgage__body c-mortgage__body--active" },
            React.createElement("table", { className: "c-amortize__table" },
                React.createElement("thead", { className: "c-amortize__head" },
                    React.createElement("tr", null,
                        React.createElement("th", null, props.t.interestRate),
                        React.createElement("th", null,
                            "10 ",
                            props.t.years),
                        React.createElement("th", null,
                            "15 ",
                            props.t.years),
                        React.createElement("th", null,
                            "20 ",
                            props.t.years),
                        React.createElement("th", null,
                            "25 ",
                            props.t.years),
                        React.createElement("th", null,
                            "30 ",
                            props.t.years))),
                React.createElement("tbody", { className: "c-amortize__body" }, props.mortgage.rateTable.map(renderRateRow)))));
    };
    var getActiveClass = function (tab) { return classnames_1.default([
        'o-btn', 'o-btn--switch', {
            'o-btn--active': tab === props.mortgageTab,
        },
    ]); };
    return (React.createElement("div", { className: "c-calc__main" },
        React.createElement("div", { className: "c-calc__top" },
            React.createElement("div", { className: "c-calc__tabs" },
                React.createElement("a", { onClick: function () { return props.onMortgageTabClick(MortgageTab_1.MortgageTab.OVERVIEW); }, className: getActiveClass(MortgageTab_1.MortgageTab.OVERVIEW) }, props.t.overview),
                React.createElement("a", { onClick: function () { return props.onMortgageTabClick(MortgageTab_1.MortgageTab.SCHEDULE); }, className: getActiveClass(MortgageTab_1.MortgageTab.SCHEDULE) }, props.t.schedule),
                React.createElement("a", { onClick: function () { return props.onMortgageTabClick(MortgageTab_1.MortgageTab.RATETABLE); }, className: getActiveClass(MortgageTab_1.MortgageTab.RATETABLE) }, props.t.rateTable))),
        props.mortgageTab === MortgageTab_1.MortgageTab.OVERVIEW ? renderOverview(props) : null,
        props.mortgageTab === MortgageTab_1.MortgageTab.SCHEDULE ? renderSchedule(props) : null,
        props.mortgageTab === MortgageTab_1.MortgageTab.RATETABLE ? renderRateTable(props) : null));
};
exports.renderMortgageResult = renderMortgageResult;
